/**
 * @description Parent host detection pattern
 */
export enum ParentEnvelopeHostPattern {
	DEV_INT = 'dev.intl.paramountplus.com',
	LOCALHOST = 'localhost',
	PREVIEW_CBS = 'preview.cbs.com',
	PREVIEW_INT = 'preview.intl.paramountplus.com',
	PREVIEW_PPLUS = 'preview.paramountplus.com',
	PROD_CBS = 'www.cbs.com',
	PROD_INT = 'intl.paramountplus.com',
	PROD_PPLUS = 'www.paramountplus.com',
	SHADOW_CBS = 'shadow.cbs.com',
	SHADOW_INT = 'shadow.intl.paramountplus.com',
	SHADOW_PPLUS = 'shadow.paramountplus.com',
	STAGE_CBS = 'stage.cbs.com',
	STAGE_INT = 'stage.intl.paramountplus.com',
	STAGE_PPLUS = 'stage.paramountplus.com',
	TEST_WWW_CBS = 'test-www.cbs.com',
	TEST_WWW_PPLUS = 'test-www.paramountplus.com',
	VIDOPSTEST_CBS = 'vidopstest.cbs.com',
	VIDOPSTEST_INT = 'vidopstest.intl.paramountplus.com',
	VIDOPSTEST_PPLUS = 'vidopstest.paramountplus.com',
}